<template>
<div class="fff">
<div class="page_title">You will need access to the device you want tomonitor to install Spylix.</div>
<div class="Take">
        Spylix needs to be installed on the target device before monitoring can begin.
        Once Spylix is installed (the process takes about 10 minutes),
        it will remain invisible,
        operating in the background to send information about the device to your Spylix account.
    </div>
<div class="YouWill">
        Grab the device you would like to monitor and start this process again.
    </div>
<div class="loginButton">OK</div>
</div>
</template>

<script>
export default {
  name: 'HelloWorld',
  data () {
    return {
      msg: ''
    }
  },
  mounted () {
  },
  methods: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.fff{width:100%;position:absolute;height:100%;background:#fff;overflow:hidden}
.Take{color:grey;line-height:20px}
.Take,.YouWill{font-size:14px;margin-left:5%;width:85%;max-width:800px}
.YouWill{color:#45484d;margin-top:40px}
.loginButton{float:left;margin-top:40px;margin-left:5%;width:280px;height:44px;line-height:44px;font-size:15px}

</style>



// WEBPACK FOOTER //
// src/components/YouWill.vue